import { DuplicateId } from "@mcleod/dispatch";
import { AutogenLayoutActionCode } from "./autogen/AutogenLayoutActionCode";

export class ActionCode extends AutogenLayoutActionCode {
    override onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "action_code",
            screenName: this.titleSingular,
            navigateToUrl: `${this.layoutName}?mode=update&key=`
        });
    }
}
